import type { FC, PropsWithChildren } from 'react';

import { CircularProgress, Stack, Typography } from '@mui/material';

import { hasValue } from 'utils/values';

interface LoadingPageProps {
  title?: string;
  description?: string;

  loading: boolean;
}

export const LoadingPage: FC<PropsWithChildren<LoadingPageProps>> = ({ title, description, loading, children }) => {
  return (
    <Stack alignItems='center' justifyContent='center' height={1} width={1} gap={2}>
      <Stack alignItems='center'>
        {hasValue(title) && (
          <Typography variant='h4' color='text.primary'>
            {title}
          </Typography>
        )}
        {hasValue(description) && (
          <Typography variant='h6' color='text.secondary'>
            {description}
          </Typography>
        )}
      </Stack>

      {loading ? <CircularProgress /> : children}
    </Stack>
  );
};
